import { injectable } from 'tsyringe';
import { DataKepesantrenanApiRepository } from '../../app/repository/api/DataKepesantrenanApiRepository';
import { DataKepesantrenan } from '../../entities/DataKepesantrenan';

@injectable()
export class DataKepesantrenanPresenter {
  private repository: DataKepesantrenanApiRepository;

  constructor(repository: DataKepesantrenanApiRepository) {
    this.repository = repository;
  }

  public getMyData(): Promise<DataKepesantrenan | null> {
    return this.repository.getMyData();
  }

  public simpan(
    pelatihanId: number,
    isPesantren: number,
    namaPesantren: string | null,
    nsp: string | null,
    alamat: string | null,
    provinsiId: number | null,
    kabupatenId: number | null,
    kecamatanId: number | null,
    peran: string | null,
    tahunBergabung: number | null,
    statusMukim: number | null,
  ): Promise<any> {
    return this.repository.simpan(
      pelatihanId,
      isPesantren,
      namaPesantren,
      nsp,
      alamat,
      provinsiId,
      kabupatenId,
      kecamatanId,
      peran,
      tahunBergabung,
      statusMukim,
    );
  }

  public simpanMaster(
    isPesantren: number,
    namaPesantren: string | null,
    nsp: string | null,
    alamat: string | null,
    provinsiId: number | null,
    kabupatenId: number | null,
    kecamatanId: number | null,
    peran: string | null,
    tahunBergabung: number | null,
    statusMukim: number | null,
  ): Promise<any> {
    return this.repository.simpanMaster(
      isPesantren,
      namaPesantren,
      nsp,
      alamat,
      provinsiId,
      kabupatenId,
      kecamatanId,
      peran,
      tahunBergabung,
      statusMukim,
    );
  }
}
